import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type GroupTitle from './group-title.vue'

export const titleLevel = [
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'custom',
] as const

export const fontWeight = [
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
] as const

// 定义组件props
export const groupTitleProps = buildProps({
  // 图标名称
  iconName: {
    type: String,
    default: '',
  },
  // 图标大小
  iconSize: {
    type: Number,
    default: 24,
  },
  // 图标颜色
  iconColor: {
    type: String,
    default: 'var(--default-icon)',
  },
  // 图标与文字间距
  iconSpace: {
    type: Number,
    default: 4,
  },
  // 主标题文字
  groupTitle: {
    type: String,
    default: '分组标题',
  },
  // 问号悬浮提示内容
  tip: {
    type: String,
    default: '',
  },
  // 问号图标大小
  tipSize: {
    type: Number,
    default: 16,
  },
  // 是否为白色背景
  isWhiteBg: {
    type: Boolean,
    default: false,
  },
  // 描述文本
  description: {
    type: String,
    default: '',
  },
  // 标题级别
  titleLevel: {
    type: String,
    values: titleLevel,
    default: 'H2',
  },
  // 标题大小
  titleFontSize: {
    type: Number,
    default: 22,
  },
  // 标题粗细
  titleWeight: {
    type: String,
    values: fontWeight,
    default: '700',
  },
  // 标题行高
  titleLineHeight: {
    type: [String, Number],
    default: 1.4,
  },
  // 标题颜色
  titleColor: {
    type: String,
    default: '#1D2129',
  },
  // 是否显示分割线
  showDivider: {
    type: Boolean,
    default: false,
  },
  // 分割线颜色
  dividerColor: {
    type: String,
    default: 'var(--color-split)',
  },
  // 分割线与文字间距
  dividerSpace: {
    type: Number,
    default: 18,
  },
  // 开启标签区插槽
  tagSlot: {
    type: Boolean,
    default: true,
  },
  // 开启操作区插槽
  rightOperateSlot: {
    type: Boolean,
    default: true,
  },
} as const)

// props
export type GroupTitleProps = ExtractPropTypes<typeof groupTitleProps> // ExtractPropTypes和defineCpmponent类似

// instance
export type GroupTitleInstance = InstanceType<typeof GroupTitle>
